import { DEFAULT_LOCALE } from '@constants';
import api from '..';
import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

export const useSectionsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'sections', api: api.sections }, queryVariables, queryConfig);

  return {
    sections: queryResult.resolvedData,
    latestSections: queryResult.latestData,
    ...queryResult,
  };
};

export const useSectionsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['sections', { ids }], api.sections.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    sections: queryResult.data || [],
    ...queryResult,
  };
};

export const useSection = ({ id, locale = DEFAULT_LOCALE }, queryConfig = {}) => {
  const queryResult = useQuery(['section', { id, locale }], api.sections.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    section: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'sections' });

export const useDeleteSection = createMutation(api.sections.remove);

export const useCreateSection = createMutation(api.sections.create);

export const useUpdateSection = createMutation(api.sections.update);

export const usePublishSection = createMutation(api.sections.publish);

export const useUnpublishSection = createMutation(api.sections.unpublish);

export const useDuplicateSection = createMutation(api.sections.duplicate);
